import React from 'react';
import Header from '../components/layout/header';
import Footerr from '../components/layout/footer';
import Errorsec from '../sections/error-sec';
import { useState } from 'react';
import Preloader from '../components/common/preloader';
import { useRef } from 'react';


const Error = () => {
        const [loading, setLoading] = useState(true);

        
    return (  
        <>
         {loading && <Preloader onFinish={() => setLoading(false)} />}
           <main className='body-bg'>
                <Header />
                <Errorsec loading={loading}/>
            </main>
            <Footerr />
        </>
    );
}
 
export default Error;